import React, {ReactElement} from 'react';
import {Draggable} from 'react-beautiful-dnd';
import {useSelector} from 'react-redux';
import {useAddElementAction} from '../../../../context/AddElementsContext';
import {useSlideErrors} from '../../../../context/SlideErrorsContext';
import {useHotkeysSlideElementKeys} from '../../../../hooks/useHotkeysSlideElementKeys';
import {IElement} from '../../../../incase-domain/elements';
import {selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import ElementMobile from '../../../elements/elementMobile';

interface ElementsMobileProps {
    slideId: string;
    elements: IElement[];
    onOptions: (id: string, silent?: boolean) => void;
}

function ElementsMobile({slideId, elements, onOptions}: ElementsMobileProps): ReactElement {
    const slide = useSelector(selectedSlideSelector);

    const {errors} = useSlideErrors();
    const addElement = useAddElementAction();

    useHotkeysSlideElementKeys((type) => addElement(type));

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: `${slide.gapBetweenMobileElements}em`,
                paddingTop: `${slide.elementPadding?.top}em`,
                paddingRight: `${slide.elementPadding?.right}em`,
                paddingBottom: `${slide.elementPadding?.bottom}em`,
                paddingLeft: `${slide.elementPadding?.left}em`,
            }}
        >
            {elements.map((element, index) => {
                const keyIndex = `slide-${slideId}-element-${element.id || index}-inner`;
                const slideErrors = errors ? errors.errors : {};
                const hasErrors =
                    (slideErrors?.elements &&
                        Array.isArray(slideErrors.elements) &&
                        slideErrors.elements[0] &&
                        Object.keys(slideErrors.elements[0]).includes(element.id)) ||
                    undefined;

                return (
                    <div key={keyIndex} style={{touchAction: 'none'}}>
                        <Draggable key={`element-draggable-mobile-${element.id}`} draggableId={element.id} index={index}>
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={`mobile-element-pos-${index}`}
                                    style={{
                                        ...provided.draggableProps.style,
                                        marginBottom: '1.41em',
                                    }}
                                >
                                    <ElementMobile
                                        element={{
                                            ...element,
                                            keyIndex,
                                        }}
                                        elementIndex={index}
                                        onOptions={onOptions}
                                        hasError={hasErrors}
                                    />
                                </div>
                            )}
                        </Draggable>
                    </div>
                );
            })}
        </div>
    );
}

export default ElementsMobile;
